import React from 'react'
import { Link } from 'react-router-dom'

import './portfolio.scss'

export default function Portfolio() {
  return (
    <section id="portfolio" className="portfolio">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Nuestros Productos</h2>
          <p>Soluciones digitales desarrolladas por SIGMATEC</p>
        </div>

        <div className="row g-4">
          {/* RESERVA YA */}
          <div className="col-lg-6">
            <div className="product-card h-100">
              <div className="product-image">
                <img
                  src="assets/img/reservaya-hero.png"
                  className="img-fluid"
                  alt="Reserva Ya"
                />
              </div>

              <div className="product-content">
                <span className="product-badge">Plataforma SaaS</span>

                <h3>Reserva Ya</h3>

                <p>
                  Gestiona reservas, clientes y horarios desde una sola
                  plataforma.
                </p>

                <div className="product-actions">
                  <a
                    href="/reserva-ya"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Conocer Reserva Ya
                    <i className="bi bi-arrow-up-right ms-2"></i>
                  </a>

                  <Link
                    to={global.TEST_REQUEST}
                    className="btn btn-product-trial"
                  >
                    <i className="bi bi-play-circle me-2"></i>
                    Probar gratis
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* E-COMMERCE */}
          <div className="col-lg-6">
            <div className="product-card h-100">
              <div className="product-image">
                <img
                  src="assets/img/eccomerce-hero.png"
                  className="img-fluid"
                  alt="EasyBuy"
                />
              </div>

              <div className="product-content">
                <span className="product-badge">Plataforma E-commerce</span>

                <h3>EasyBuy</h3>

                <p>
                  Una solución completa para vender, comprar y gestionar
                  productos online.
                </p>

                <div className="product-actions">
                  <a
                    href="/easybuy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary"
                  >
                    Conocer EasyBuy
                    <i className="bi bi-arrow-up-right ms-2"></i>
                  </a>

                  <Link
                    to={global.EASYBUY_TRIAL}
                    className="btn btn-product-trial"
                  >
                    <i className="bi bi-play-circle me-2"></i>
                    Probar gratis
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
